 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER601IMNOTGOINGTOHAVEAFALLINGOUT from '@/components/0_chapter601imnotgoingtohaveafallingout'
 import A_CHAPTER602HEROPPORTUNITIES from '@/components/1_chapter602heropportunities'
 import A_CHAPTER603ICANTSTOPWORRYINGANDFEELINGJEALOUS from '@/components/2_chapter603icantstopworryingandfeelingjealous'
 import A_CHAPTER604HEWASTOOASHAMEDTOMEETANYONE from '@/components/3_chapter604hewastooashamedtomeetanyone'
 import A_CHAPTER605DONTLEAVEME from '@/components/4_chapter605dontleaveme'
 import A_CHAPTER606STIRRER from '@/components/5_chapter606stirrer'
 import A_CHAPTER607CANYOULETMEGOTONIGHT from '@/components/6_chapter607canyouletmegotonight'
 import A_CHAPTER608MOURNING from '@/components/7_chapter608mourning'
 import A_CHAPTER609TEST from '@/components/8_chapter609test'
 import A_CHAPTER610PRUNUSARMENIACAMAXIM from '@/components/9_chapter610prunusarmeniacamaxim'
 import A0_CHAPTER611WITHADAUGHTERINLAWANDNOFATHER from '@/components/10_chapter611withadaughterinlawandnofather'
 import A1_CHAPTER612IJUSTHAPPENEDTOBEDRESSEDLIKETHIS from '@/components/11_chapter612ijusthappenedtobedressedlikethis'
 import A2_CHAPTER613IDIDITFORMYSON from '@/components/12_chapter613ididitformyson'
 import A3_CHAPTER614STOPMAKINGCONTACTWITHHIM from '@/components/13_chapter614stopmakingcontactwithhim'
 import A4_CHAPTER615HEALSOSAIDTHATHEDIDNTLIKEIT from '@/components/14_chapter615healsosaidthathedidntlikeit'
 import A5_CHAPTER616EXCLUSIVESMALLCOURTYARD from '@/components/15_chapter616exclusivesmallcourtyard'
 import A6_CHAPTER617ZURICHISOUTOFTOWN from '@/components/16_chapter617zurichisoutoftown'
 import A7_CHAPTER618WHITEDOG from '@/components/17_chapter618whitedog'
 import A8_CHAPTER619ILLGOTOJINGXIANTOFINDYOU from '@/components/18_chapter619illgotojingxiantofindyou'
 import A9_CHAPTER620LILWHITESEEMSTOLIKEYOUALOT from '@/components/19_chapter620lilwhiteseemstolikeyoualot'
 import A0_CHAPTER6214MILLIONTOME from '@/components/20_chapter6214milliontome'
 import A1_CHAPTER622ITWASWORTHIT from '@/components/21_chapter622itwasworthit'
 import A2_CHAPTER623IAMINURGENTNEEDOFANENDTOTHEFIRE from '@/components/22_chapter623iaminurgentneedofanendtothefire'
 import A3_CHAPTER624LITTLEBIESHENGNEWMARRIAGE from '@/components/23_chapter624littlebieshengnewmarriage'
 import A4_CHAPTER625CURIOSITYISSTRONG from '@/components/24_chapter625curiosityisstrong'
 import A5_CHAPTER626TIMELY from '@/components/25_chapter626timely'
 import A6_CHAPTER627IHAVEANOTHERREQUESTFORYOU from '@/components/26_chapter627ihaveanotherrequestforyou'
 import A7_CHAPTER628ISANUNFAMILIARNUMBER from '@/components/27_chapter628isanunfamiliarnumber'
 import A8_CHAPTER629THEFIRSTHUMILIATIONINHISTORY from '@/components/28_chapter629thefirsthumiliationinhistory'
 import A9_CHAPTER630WHATDIDYOUBUYTHATFOR from '@/components/29_chapter630whatdidyoubuythatfor'
 import A0_CHAPTER631HOWSHAMELESS from '@/components/30_chapter631howshameless'
 import A1_CHAPTER632WHATISYOURSISMINE from '@/components/31_chapter632whatisyoursismine'
 import A2_CHAPTER633TWOMONEYTREE from '@/components/32_chapter633twomoneytree'
 import A3_CHAPTER634WHATDOYOUFEELGUILTYABOUT from '@/components/33_chapter634whatdoyoufeelguiltyabout'
 import A4_CHAPTER635NOTTOOLATE from '@/components/34_chapter635nottoolate'
 import A5_CHAPTER636DRUNKWOMEN from '@/components/35_chapter636drunkwomen'
 import A6_CHAPTER637YOUDONTNEEDTOUNDERSTAND from '@/components/36_chapter637youdontneedtounderstand'
 import A7_CHAPTER638YOURMOTHERISATALENTEDGIRL from '@/components/37_chapter638yourmotherisatalentedgirl'
 import A8_CHAPTER639LOSINGAMANANDLOSINGASOLDIER from '@/components/38_chapter639losingamanandlosingasoldier'
 import A9_CHAPTER640LADYLU from '@/components/39_chapter640ladylu'
 import A0_CHAPTER641ITSGOODTOHAVEFUN from '@/components/40_chapter641itsgoodtohavefun'
 import A1_CHAPTER642YOURESOSMART from '@/components/41_chapter642youresosmart'
 import A2_CHAPTER643KEYPEOPLEAPPEAR from '@/components/42_chapter643keypeopleappear'
 import A3_CHAPTER644IAMTHEDAUGHTEROFKIKUXIANG from '@/components/43_chapter644iamthedaughterofkikuxiang'
 import A4_CHAPTER645NATURALFATE from '@/components/44_chapter645naturalfate'
 import A5_CHAPTER646DIFFICULTCHOICES from '@/components/45_chapter646difficultchoices'
 import A6_CHAPTER647IHAVENTTAKENCAREOFANYONEYET from '@/components/46_chapter647ihaventtakencareofanyoneyet'
 import A7_CHAPTER648FIRSTKISS from '@/components/47_chapter648firstkiss'
 import A8_CHAPTER649APLACEOFNEGLECT from '@/components/48_chapter649aplaceofneglect'
 import A9_CHAPTER650WHOKNOWSHERBEST from '@/components/49_chapter650whoknowsherbest'
 import A0_CHAPTER651ABOUTYOURBROTHER from '@/components/50_chapter651aboutyourbrother'
 import A1_CHAPTER652LETSSLEEPTOGETHERATNIGHT from '@/components/51_chapter652letssleeptogetheratnight'
 import A2_CHAPTER653THREEDAYSOFFAREWELL from '@/components/52_chapter653threedaysoffarewell'
 import A3_CHAPTER654SWAP from '@/components/53_chapter654swap'
 import A4_CHAPTER655LETSGETDIVORCED from '@/components/54_chapter655letsgetdivorced'
 import A5_CHAPTER656NEWHOME from '@/components/55_chapter656newhome'
 import A6_CHAPTER657IWANTTOSEEHOWYOUREGOINGTOPICKUPTHELOOT from '@/components/56_chapter657iwanttoseehowyouregoingtopickuptheloot'
 import A7_CHAPTER658HOWNICEITWOULDBETOHAVEAYOUNGERBROTHER from '@/components/57_chapter658howniceitwouldbetohaveayoungerbrother'
 import A8_CHAPTER659BADLYNEEDED from '@/components/58_chapter659badlyneeded'
 import A9_CHAPTER660FOURTHMASTERHASSOMETHINGTODO from '@/components/59_chapter660fourthmasterhassomethingtodo'
 import A0_CHAPTER661WEVEBROKENUP from '@/components/60_chapter661wevebrokenup'
 import A1_CHAPTER662YOUTHINKTOOMUCH from '@/components/61_chapter662youthinktoomuch'
 import A2_CHAPTER663HEACTUALLYHUNGUPONHER from '@/components/62_chapter663heactuallyhunguponher'
 import A3_CHAPTER664HOWWILLYOUREPAYME from '@/components/63_chapter664howwillyourepayme'
 import A4_CHAPTER665WHATDOESTHISMEAN from '@/components/64_chapter665whatdoesthismean'
 import A5_CHAPTER666WISHFULTHINKING from '@/components/65_chapter666wishfulthinking'
 import A6_CHAPTER667UNACCUSTOMED from '@/components/66_chapter667unaccustomed'
 import A7_CHAPTER668HEISTOOFONDOFYOU from '@/components/67_chapter668heistoofondofyou'
 import A8_CHAPTER669DOESMASTERSILIKEME from '@/components/68_chapter669doesmastersilikeme'
 import A9_CHAPTER670ILLBRINGUPTHEPOTIFICANTBRINGUPTHETEAPOTIETHETEAPOTIFICANTBRINGUPTHETEAPOTWHENIHAVETOBRINGUPTHETEAPOT from '@/components/69_chapter670illbringupthepotificantbringuptheteapotietheteapotificantbringuptheteapotwhenihavetobringuptheteapot'
 import A0_CHAPTER671YOUREINTERESTEDINTHEGUFAMILY from '@/components/70_chapter671youreinterestedinthegufamily'
 import A1_CHAPTER672STREETROBBERIES from '@/components/71_chapter672streetrobberies'
 import A2_CHAPTER673LUXURYCLUBHOUSE from '@/components/72_chapter673luxuryclubhouse'
 import A3_CHAPTER674BANQUETISTHEKEY from '@/components/73_chapter674banquetisthekey'
 import A4_CHAPTER675HESTILLSHOWEDUP from '@/components/74_chapter675hestillshowedup'
 import A5_CHAPTER676EXTRAMARITALAFFAIR from '@/components/75_chapter676extramaritalaffair'
 import A6_CHAPTER677BYWHOM from '@/components/76_chapter677bywhom'
 import A7_CHAPTER678THREATENHERWITHALMS from '@/components/77_chapter678threatenherwithalms'
 import A8_CHAPTER679THEREWASNOONEELSEAPARTFROMHIM from '@/components/78_chapter679therewasnooneelseapartfromhim'
 import A9_CHAPTER680WHATISTHEIRPURPOSE from '@/components/79_chapter680whatistheirpurpose'
 import A0_CHAPTER681IMAFRAIDWEWONTBEABLETOHOLDOFFTONIGHT from '@/components/80_chapter681imafraidwewontbeabletoholdofftonight'
 import A1_CHAPTER682YOUHAVETOHOLDON from '@/components/81_chapter682youhavetoholdon'
 import A2_CHAPTER683THETRUTHISCLEAR from '@/components/82_chapter683thetruthisclear'
 import A3_CHAPTER684CANTSEEHERCRY from '@/components/83_chapter684cantseehercry'
 import A4_CHAPTER685WANTTONEGOTIATEWITHME from '@/components/84_chapter685wanttonegotiatewithme'
 import A5_CHAPTER686MASTERFOURIMISSYOU from '@/components/85_chapter686masterfourimissyou'
 import A6_CHAPTER687TOOMUCHDIFFERENCE from '@/components/86_chapter687toomuchdifference'
 import A7_CHAPTER688THISISTHERHYTHMOFREMARRIAGE from '@/components/87_chapter688thisistherhythmofremarriage'
 import A8_CHAPTER689THERING from '@/components/88_chapter689thering'
 import A9_CHAPTER690MUTUALTRUST from '@/components/89_chapter690mutualtrust'
 import A0_CHAPTER691THEONLYTHINGIMAFRAIDOFISTHATYOUREBEINGCHEATED from '@/components/90_chapter691theonlythingimafraidofisthatyourebeingcheated'
 import A1_CHAPTER692LUQIANQIWILLNOTLOSE from '@/components/91_chapter692luqianqiwillnotlose'
 import A2_CHAPTER693STARTWORKINGASMYASSISTANTTOMORROW from '@/components/92_chapter693startworkingasmyassistanttomorrow'
 import A3_CHAPTER694ILUQIANQIWILLNOTLOSE from '@/components/93_chapter694iluqianqiwillnotlose'
 import A4_CHAPTER695SHEISYOURWEAKSPOT from '@/components/94_chapter695sheisyourweakspot'
 import A5_CHAPTER696TOOGREEDY from '@/components/95_chapter696toogreedy'
 import A6_CHAPTER697DONTWANTTOGIVEUPSOMEONEELSE from '@/components/96_chapter697dontwanttogiveupsomeoneelse'
 import A7_CHAPTER698MYMAN from '@/components/97_chapter698myman'
 import A8_CHAPTER699MOMMYYOURECRYING from '@/components/98_chapter699mommyyourecrying'
 import A9_CHAPTER700TOUGHENEDASSILKOFASPARAGUS from '@/components/99_chapter700toughenedassilkofasparagus'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter601imnotgoingtohaveafallingout",
 			"name" : "0_chapter601imnotgoingtohaveafallingout",
 			"component" : A_CHAPTER601IMNOTGOINGTOHAVEAFALLINGOUT
 		},
 		{
 			"path" : "/1_chapter602heropportunities",
 			"name" : "1_chapter602heropportunities",
 			"component" : A_CHAPTER602HEROPPORTUNITIES
 		},
 		{
 			"path" : "/2_chapter603icantstopworryingandfeelingjealous",
 			"name" : "2_chapter603icantstopworryingandfeelingjealous",
 			"component" : A_CHAPTER603ICANTSTOPWORRYINGANDFEELINGJEALOUS
 		},
 		{
 			"path" : "/3_chapter604hewastooashamedtomeetanyone",
 			"name" : "3_chapter604hewastooashamedtomeetanyone",
 			"component" : A_CHAPTER604HEWASTOOASHAMEDTOMEETANYONE
 		},
 		{
 			"path" : "/4_chapter605dontleaveme",
 			"name" : "4_chapter605dontleaveme",
 			"component" : A_CHAPTER605DONTLEAVEME
 		},
 		{
 			"path" : "/5_chapter606stirrer",
 			"name" : "5_chapter606stirrer",
 			"component" : A_CHAPTER606STIRRER
 		},
 		{
 			"path" : "/6_chapter607canyouletmegotonight",
 			"name" : "6_chapter607canyouletmegotonight",
 			"component" : A_CHAPTER607CANYOULETMEGOTONIGHT
 		},
 		{
 			"path" : "/7_chapter608mourning",
 			"name" : "7_chapter608mourning",
 			"component" : A_CHAPTER608MOURNING
 		},
 		{
 			"path" : "/8_chapter609test",
 			"name" : "8_chapter609test",
 			"component" : A_CHAPTER609TEST
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js